import { render } from "./DeleteChatConfirm.vue?vue&type=template&id=14b240f4&scoped=true"
import script from "./DeleteChatConfirm.vue?vue&type=script&lang=js"
export * from "./DeleteChatConfirm.vue?vue&type=script&lang=js"

import "./DeleteChatConfirm.vue?vue&type=style&index=0&id=14b240f4&lang=scss&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14b240f4"]])

export default __exports__